export const SLIDE_SPACING = {
    MOBILE: 16,
    TABLET: 24,
    DESKTOP: 32,
};
export const SLIDES_AMOUNT_DESKTOP = 4;
export const SLIDES_AMOUNT_DESKTOP_LARGE = 5;
export var SlideCropped;
(function (SlideCropped) {
    SlideCropped[SlideCropped["LARGE"] = 0.6] = "LARGE";
    SlideCropped[SlideCropped["MEDIUM"] = 0.25] = "MEDIUM";
    SlideCropped[SlideCropped["SMALL"] = 0.15] = "SMALL";
})(SlideCropped || (SlideCropped = {}));
